// extracted by mini-css-extract-plugin
module.exports = {"root":"FixedTopBanner_root__3MxNH","link":"FixedTopBanner_link__1H2tK"};